import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'
import { jwtDecode } from 'jwt-decode'
// import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
// import { auth } from '../../firebase';

export const customer_register = createAsyncThunk(
  'auth/customer_register',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/customer/customer-register', info)
      localStorage.setItem('customerToken', data.token)
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const send_email_link = createAsyncThunk(
  'auth/send_email_link',
  async (email, { rejectWithValue, fulfillWithValue }) => {
    try {
      await api.post('/send-email-link', { email })
      localStorage.setItem('emailForRegistration', email)
      localStorage.setItem('emailVerificationAttempt', Date.now())
      return fulfillWithValue({ message: 'Email link sent' })
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { error: 'Failed to send email' }
      )
    }
  }
)

export const verify_email_token = createAsyncThunk(
  'auth/verify_email_token',
  async (token, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        '/verify-token',
        { token },
        { withCredentials: true } // important for cookies
      )

      localStorage.removeItem('emailForRegistration')

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { error: 'Invalid or expired token' }
      )
    }
  }
)
// export const customer_register = createAsyncThunk(
//   'auth/customer_register',
//   async (userData, { rejectWithValue, fulfillWithValue }) => {
//     try {
//       let user;

//       // Check if user is already verified (email link flow)
//       if (userData.uid) {
//         user = auth.currentUser;
//         await updateProfile(user, { displayName: userData.name });
//       } else {
//         // Traditional email/password flow
//         const userCredential = await createUserWithEmailAndPassword(
//           auth,
//           userData.email,
//           userData.password
//         );
//         user = userCredential.user;
//         await updateProfile(user, { displayName: userData.name });
//       }

//       // Send data to your backend
//       const { data } = await api.post('/customer/customer-register', {
//         uid: user.uid,
//         name: userData.name,
//         email: user.email,
//         phone: userData.phone,
//         userType: userData.userType,
//         address: userData.address,
//         printHouseName: userData.printHouseName,
//       });

//       localStorage.setItem('customerToken', data.token);
//       return fulfillWithValue(data);

//     } catch (error) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );
// End Method

export const customer_login = createAsyncThunk(
  'auth/customer_login',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/customer/customer-login', info)
      localStorage.setItem('customerToken', data.token)
      // console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const customer_request_printHouse = createAsyncThunk(
  'auth/customer_request_printHouse',
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/customer/request', info)

      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const customer_request_email = createAsyncThunk(
  'auth/customer_request_email',
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post('/customer/request-email', payload) // payload = { email: "..." }
      return fulfillWithValue(data)
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const customer_update_password = createAsyncThunk(
  'auth/customer_update_password',
  async (obj, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        '/customer/customer-update-password',
        obj,
        {
          withCredentials: true,
        }
      )

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)

export const customer_update = createAsyncThunk(
  'auth/customer_update',
  async (obj, { rejectWithValue }) => {
    try {
      const { data } = await api.put('/customer/customer-update', obj, {
        withCredentials: true,
      });
        return data; 
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: 'Server Error' });
    }
  }
);

// End Method

export const get_customer = createAsyncThunk(
  'auth/get_customer',
  async (userId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/get-customer/${userId}`, {
        withCredentials: true,
      })

      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)
// end method

const decodeToken = (token) => {
  if (!token) return null;
  try {
    return jwtDecode(token);
  } catch (err) {
    console.error('Failed to decode token:', err);
    return null;
  }
};
// End Method

export const authReducer = createSlice({
  name: 'auth',
  initialState: {
    loader: false,
    customerProfile: '',
    customerIdReturn: '',
    userInfo: decodeToken(localStorage.getItem('customerToken')),
    errorMessage: '',
    successMessage: '',

    errorMessageEmail: '',
    successMessageEmail: '',
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
    messageEmailClear: (state, _) => {
      state.errorMessageEmail = ''
      state.successMessageEmail = ''
    },
    user_reset: (state, _) => {
      state.userInfo = ''
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(customer_register.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(customer_register.rejected, (state, { payload }) => {
        state.errorMessage = payload.error
        state.loader = false
      })
      .addCase(customer_register.fulfilled, (state, { payload }) => {
        const userInfo = decodeToken(payload.token)
        state.successMessage = payload.message
        state.loader = false
        state.userInfo = userInfo
      })

      .addCase(send_email_link.fulfilled, (state, action) => {
        state.success = action.payload.message
      })
      .addCase(verify_email_token.fulfilled, (state, action) => {
        state.email = action.payload.email
      })

      .addCase(customer_request_printHouse.pending, (state) => {
        state.loader = true
        state.errorMessage = null
        state.successMessage = null
      })
      .addCase(customer_request_printHouse.rejected, (state, { payload }) => {
        state.errorMessage = payload?.error || 'Something went wrong'
        state.loader = false
      })
      .addCase(customer_request_printHouse.fulfilled, (state, { payload }) => {
        // const userInfo = decodeToken(payload.token)
        state.successMessage = 'Request sent successfully'
        state.loader = false
      })

      .addCase(customer_request_email.pending, (state) => {
        state.loader = true
      })
      .addCase(customer_request_email.rejected, (state, { payload }) => {
        state.errorMessageEmail = payload?.error || 'Something went wrong'
        state.loader = false
      })
      .addCase(customer_request_email.fulfilled, (state, { payload }) => {
        state.successMessageEmail =
          payload.message || 'Request sent successfully'
        state.loader = false
        state.customerIdReturn = payload.customerIdReturn
        // state.userInfo = payload.customer
      })
.addCase(customer_update.fulfilled, (state, { payload }) => {
  state.loader = false;
  state.successMessage = payload.message;

  if (payload.token) {
    const userInfo = decodeToken(payload.token);
    state.userInfo = userInfo; // update Redux state with new info
    localStorage.setItem('customerToken', payload.token);
    
  }
})
      .addCase(customer_update.rejected, (state, { payload }) => {
        state.errorMessage = payload.error
        state.loader = false
      })
      .addCase(customer_update_password.fulfilled, (state, { payload }) => {
        state.loader = false
        // state.couponCodes = payload.couponCodes
        state.successMessage = payload.message
      })
      .addCase(customer_update_password.rejected, (state, { payload }) => {
        state.errorMessage = payload.error
        state.loader = false
      })

      .addCase(customer_login.pending, (state, { payload }) => {
        state.loader = true
      })
      .addCase(customer_login.rejected, (state, { payload }) => {
        state.errorMessage = payload.error
        state.loader = false
      })
      .addCase(customer_login.fulfilled, (state, { payload }) => {
        const userInfo = decodeToken(payload.token)
        state.successMessage = payload.message
        state.loader = false
        state.userInfo = userInfo
      })
      .addCase(get_customer.fulfilled, (state, { payload }) => {
        state.customerProfile = payload.customerProfile
      })
  },
})
export const { messageClear, messageEmailClear, user_reset } =
  authReducer.actions
export default authReducer.reducer
